<template>
  <div class="login-page">
    <div class="columns is-centered is-vcentered">
      <div class="column is-half-tablet is-one-third-desktop">
        <div class="login-form box">
          <h1 class="title has-text-centered">Log in</h1>

          <!-- Errors -->
          <ul v-if="errors.length" class="notification is-danger">
            <li v-for="(err, i) in errors" :key="i">{{ err }}</li>
          </ul>

          <form @submit.prevent="submitForm">
            <div class="field">
              <label class="label">E-Mail / Username</label>
              <div class="control control-wide">
                <input
                  v-model="username"
                  class="input is-medium"
                  type="text"
                  placeholder="Enter your username or email"
                />
              </div>
            </div>

            <div class="field">
              <label class="label">Password</label>
              <div class="control control-wide">
                <input
                  v-model="password"
                  class="input is-medium"
                  type="password"
                  placeholder="Enter your password"
                />
              </div>
            </div>

            <div class="field">
              <div class="control has-text-centered">
                <button
                  class="button is-primary is-medium is-fullwidth"
                  type="submit"
                  :disabled="loading"
                >
                  <span v-if="loading">Logging in...</span>
                  <span v-else>Log in</span>
                </button>
              </div>
            </div>
          </form>

          <!-- Modal for concurrent sessions -->
          <div v-if="showTooManyUsersModal" class="modal is-active">
            <div class="modal-background"></div>
            <div class="modal-card">
              <header class="modal-card-head">
                <p class="modal-card-title">Connexion refusée</p>
                <button
                  class="delete"
                  aria-label="close"
                  @click="showTooManyUsersModal = false"
                ></button>
              </header>
              <section class="modal-card-body has-text-centered">
                <p class="has-text-danger">
                  {{
                    modalMessage ||
                    "Trop d'utilisateurs connectés en même temps."
                  }}
                </p>
              </section>
              <footer class="modal-card-foot is-justify-content-center">
                <button
                  class="button is-primary"
                  @click="showTooManyUsersModal = false"
                >
                  OK
                </button>
              </footer>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LogIn',
  data() {
    return {
      username: '',
      password: '',
      errors: [],
      loading: false,
      showTooManyUsersModal: false, // 👈 trigger for modal
      modalMessage: '', // 👈 text inside modal
    };
  },
  methods: {
    async submitForm() {
      this.errors = [];
      if (!this.username || !this.password) {
        this.errors.push('Please fill in both fields.');
        return;
      }
      if (this.loading) return;
      this.loading = true;

      try {
        // 1) JWT login
        await this.$store.dispatch('logIn', {
          username: this.username,
          password: this.password,
        });

        // 2) Create ActiveSession (MANDATORY)

        // 3) Now user has an active organization
        this.$store.commit('SET_HAS_LICENSE_SESSION', true);

        // 4) Redirect
        this.$router.push('/dashboard');
      } catch (error) {
        const status = error?.response?.status;
        const payload = error?.response?.data;

        switch (status) {
          case 400:
          case 401:
            this.errors.push('Invalid credentials.');
            break;

          case 403:
            // Concurrent session detected
            this.$store.commit('CLEAR_TOKENS');
            this.modalMessage =
              payload?.detail || "Trop d'utilisateurs connectés.";
            this.showTooManyUsersModal = true; // 👉 open modal only
            return; // 🚨 stop here, don't add to errors

          case 429:
            this.errors.push(
              payload?.detail || 'Too many attempts. Please wait and try again.'
            );
            break;

          default:
            if (typeof payload === 'string') {
              this.errors.push(payload);
            } else if (payload && typeof payload === 'object') {
              for (const k in payload) {
                const v = payload[k];
                this.errors.push(
                  Array.isArray(v) ? `${k}: ${v.join(', ')}` : `${k}: ${v}`
                );
              }
            } else if (error?.message) {
              this.errors.push(error.message);
            } else {
              this.errors.push('Login failed. Please try again.');
            }
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style scoped>
.login-page {
  height: 100vh;
}
.control-wide {
  width: 100%;
}
</style>
